export default {
	ACCESS_TOKEN: 'accessToken',
	REFRESH_TOKEN: 'refreshToken',
	USE_LIGHT_THEME: 'useLightTheme',
	IS_SIDEBAR_OPEN: 'sidebarOpen'
};
